import { useDispatch, useSelector } from "react-redux";
import { dataActions } from "../../../shared/store/dataSlice";
import { CloseBtn } from "../svg/AllSvg";
import { useTranslation } from "react-i18next";
// import { useNavigate, useParams } from "react-router-dom";
import { uiActions } from "../../../shared/store/uiSlice";

const LanguageChangeModal = () => {
    const langOpen: boolean = useSelector((state: any) => state.data.langOpen);
    // const selectLang: any = useSelector((state: any) => state.data.selectLang);
    const lang: string = useSelector((state: any) => state.ui.lang);
    // const navigate = useNavigate();
    const dispatch = useDispatch();
    // const params = useParams();
    const { t, i18n } = useTranslation('common');

    document.onkeydown = function (evt: any) {
        if (evt.keyCode === 27) {
            dispatch(dataActions.setLangOpen(false))
        }
    };

    const handleChange = () => {
		const newLang = lang === 'en' ? 'hi' : 'en';
		dispatch(uiActions.changeLang(newLang));
		i18n.changeLanguage(newLang);

		const selectEl = document.querySelector<HTMLSelectElement>('.goog-te-combo');

		if (selectEl) {
			if (newLang === 'hi') {
				// Translate to Hindi
				selectEl.value = 'hi';
			} else {
				// Reset to original English
				selectEl.value = 'en';
			}
			selectEl.dispatchEvent(new Event('change'));
		}

		dispatch(dataActions.setLangOpen(false));
	};

    return (
        <>
            {langOpen &&
                <div className="fixed inset-0 z-[34] overflow-y-hidden top-0 ">
                    <div
                        className="fixed inset-0 w-full h-full bg-[rgba(216,216,216,0.60)] backdrop-blur-[15px]" onClick={() => dispatch(dataActions.setLangOpen(false))}
                    ></div>
                    <div className="flex justify-center items-center min-h-screen">
                        <div className="m-[15px] md:mx-auto bg-white rounded-[15px] w-full h-auto xsm:w-[400px] relative p-[24px] shadow-[0px_20px_24px_-4px_rgba(16,24,40_0.08),0px_8px_8px_-4px_rgba(16,24,40,0.03)]">
                            <img src={require('../../../assets/images/popup-bg.png')} alt="lang-popup-bg" className="absolute top-0 left-0 right-0 bottom-0 w-full h-full rounded-[15px]" />

                            <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="absolute top-[15px] right-[15px] rounded-full min-w-[23px] h-[23px] flex items-center justify-center focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] z-[2]" onClick={() => dispatch(dataActions.setLangOpen(false))}>
                                <CloseBtn />
                            </button>

                            <div className="flex flex-col gap-[15px] xlx:gap-[20px] relative z-[1]">
                                <img src={require("../../../assets/images/lang.png")} alt="language" className="w-fit h-fit ml-[-5px]" />
                                <h3 className="text-primaryText font-bold max-w-[440px]">{lang === "en" ? `Are you sure you want Change language to हिन्दी ?` : `क्या आप वाकई भाषा को English में बदलना चाहते हैं?`}</h3>

                                <div className="flex items-center gap-[12px] mt-[15px] xlx:mt-[20px] xxs:flex-row flex-col">
                                    <button className="flex items-center justify-center px-[15px] bg-primary text-white uppercase text-sm font-bold tracking-wide min-h-[40px] gap-[10px] hover:shadow-[0_0_0_3px_#1b98525e] focus:shadow-[0_0_0_3px_#1b98525e] w-full whitespace-nowrap" onClick={handleChange} autoFocus={true}>{t("lang.yes")}</button>
                                    <button className="flex items-center justify-center px-[15px] bg-[#ABABAB] text-white uppercase text-sm font-bold tracking-wide min-h-[40px] gap-[10px] hover:shadow-[0_0_0_3px_#0000005e] focus:shadow-[0_0_0_3px_#0000005e] w-full whitespace-nowrap" onClick={() => dispatch(dataActions.setLangOpen(false))}>{t("lang.no")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default LanguageChangeModal;